import { render, staticRenderFns } from "./TextInputWithFormattedOverlay.vue?vue&type=template&id=53c69009&scoped=true"
import script from "./TextInputWithFormattedOverlay.vue?vue&type=script&lang=ts"
export * from "./TextInputWithFormattedOverlay.vue?vue&type=script&lang=ts"
import style0 from "./TextInputWithFormattedOverlay.vue?vue&type=style&index=0&id=53c69009&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c69009",
  null
  
)

export default component.exports